/**
 * «Torna da dove vieni» delle viste senza voce di menu.
 *
 * Si torna alla pagina precedente quando ce n'e una dell'app in questa
 * scheda del browser; aperta da un link diretto, la vista non ha un prima e
 * il pulsante porta al ripiego, di norma il cruscotto. Senza il ripiego
 * `navigate(-1)` uscirebbe dall'app, o non farebbe nulla.
 */

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Il router numera le voci della cronologia che crea: `idx` 0 e la prima
 * pagina dell'app aperta in questa scheda, e le sostituzioni lo conservano.
 */
export function haUnPrima(statoCronologia: unknown): boolean {
  const idx = (statoCronologia as { idx?: unknown } | null)?.idx;
  return typeof idx === 'number' && idx > 0;
}

export function useIndietro(ripiego: string): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    if (haUnPrima(window.history.state)) navigate(-1);
    else navigate(ripiego, { replace: true });
  }, [navigate, ripiego]);
}
